import { ExtraTermsModel } from "../models/ExtraTerms";
import { StixTermsModel } from "../models/StixTerms";
import { api } from "./api";

export class OccService {
  static getTerms() {
    return api.get<StixTermsModel>("/stix/content/app-regulamento");
  }

  static getExtraTerms() {
    return api.get<ExtraTermsModel>("stix/content/extra-regulamento");
  }

  static getPaTerms() {
    return api.get("/stix/content/paodeacucar-regulamento");
  }

  static getPrivacyTerms() {
    return api.get("/stix/content/privacidade-regulamento");
  }

  static getDsTerms() {
    return api.get("/stix/content/drogasil-regulamento");
  }

  static getDrTerms() {
    return api.get("/stix/content/drogaraia-regulamento");
  }

  static getPartners() {
    return api.get("/stix/content/app-stix-para-empresas");
  }
}
